// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/policy/v1/policy.proto" (package "agency.policy.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../google/protobuf/duration";
/**
 * StreamSource defines a source for stream mirroring/sourcing.
 *
 * @generated from protobuf message agency.policy.v1.StreamSource
 */
export interface StreamSource {
    /**
     * name is the source stream name.
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * opt_start_seq is the optional starting sequence.
     *
     * @generated from protobuf field: uint64 opt_start_seq = 2
     */
    optStartSeq: bigint;
    /**
     * opt_start_time is the optional starting timestamp.
     *
     * @generated from protobuf field: google.protobuf.Duration opt_start_time = 3
     */
    optStartTime?: Duration;
    /**
     * filter_subject filters messages by subject.
     *
     * @generated from protobuf field: string filter_subject = 4
     */
    filterSubject: string;
    /**
     * external references an external NATS system.
     *
     * @generated from protobuf field: agency.policy.v1.ExternalStream external = 5
     */
    external?: ExternalStream;
    /**
     * subject_transforms define subject mapping rules for this source.
     *
     * @generated from protobuf field: repeated agency.policy.v1.SubjectTransform subject_transforms = 6
     */
    subjectTransforms: SubjectTransform[];
    /**
     * domain is the JetStream domain of the source stream.
     *
     * @generated from protobuf field: string domain = 7
     */
    domain: string;
}
/**
 * ExternalStream references an external NATS system.
 *
 * @generated from protobuf message agency.policy.v1.ExternalStream
 */
export interface ExternalStream {
    /**
     * api_prefix is the API subject prefix for the external system.
     *
     * @generated from protobuf field: string api_prefix = 1
     */
    apiPrefix: string;
    /**
     * deliver_prefix is the delivery subject prefix.
     *
     * @generated from protobuf field: string deliver_prefix = 2
     */
    deliverPrefix: string;
}
/**
 * Republish defines message republishing configuration.
 *
 * @generated from protobuf message agency.policy.v1.Republish
 */
export interface Republish {
    /**
     * source is the source subject pattern.
     *
     * @generated from protobuf field: string source = 1
     */
    source: string;
    /**
     * destination is the destination subject.
     *
     * @generated from protobuf field: string destination = 2
     */
    destination: string;
    /**
     * headers_only republishes only headers, not payload.
     *
     * @generated from protobuf field: bool headers_only = 3
     */
    headersOnly: boolean;
}
/**
 * SubjectTransform defines subject name transformation rules.
 *
 * @generated from protobuf message agency.policy.v1.SubjectTransform
 */
export interface SubjectTransform {
    /**
     * src is the source subject pattern.
     *
     * @generated from protobuf field: string src = 1
     */
    src: string;
    /**
     * dest is the destination subject pattern.
     *
     * @generated from protobuf field: string dest = 2
     */
    dest: string;
}
/**
 * StreamPlacement defines stream placement constraints in clustered deployments.
 *
 * @generated from protobuf message agency.policy.v1.StreamPlacement
 */
export interface StreamPlacement {
    /**
     * cluster is the target cluster name.
     *
     * @generated from protobuf field: string cluster = 1
     */
    cluster: string;
    /**
     * tags are placement constraint tags (e.g., "edge", "platform", "us-east").
     *
     * @generated from protobuf field: repeated string tags = 2
     */
    tags: string[];
}
/**
 * StreamConsumerLimits defines stream-level consumer constraints.
 *
 * @generated from protobuf message agency.policy.v1.StreamConsumerLimits
 */
export interface StreamConsumerLimits {
    /**
     * inactive_threshold is the duration after which inactive consumers are cleaned up.
     *
     * @generated from protobuf field: google.protobuf.Duration inactive_threshold = 1
     */
    inactiveThreshold?: Duration;
    /**
     * max_ack_pending is the maximum number of outstanding unacknowledged messages.
     *
     * @generated from protobuf field: uint32 max_ack_pending = 2
     */
    maxAckPending: number;
}
/**
 * StreamPolicy defines stream configuration.
 *
 * @generated from protobuf message agency.policy.v1.StreamPolicy
 */
export interface StreamPolicy {
    /**
     * retention is the retention policy.
     *
     * @generated from protobuf field: agency.policy.v1.RetentionPolicy retention = 1
     */
    retention: RetentionPolicy;
    /**
     * replicas is the number of stream replicas.
     *
     * @generated from protobuf field: uint32 replicas = 2
     */
    replicas: number;
    /**
     * max_age is the maximum message age.
     *
     * @generated from protobuf field: google.protobuf.Duration max_age = 3
     */
    maxAge?: Duration;
    /**
     * max_msgs_per_subject is the maximum messages per subject.
     *
     * @generated from protobuf field: int64 max_msgs_per_subject = 4
     */
    maxMsgsPerSubject: bigint;
    /**
     * max_msgs is the maximum total messages.
     *
     * @generated from protobuf field: int64 max_msgs = 5
     */
    maxMsgs: bigint;
    /**
     * max_bytes is the maximum total bytes.
     *
     * @generated from protobuf field: int64 max_bytes = 6
     */
    maxBytes: bigint;
    /**
     * max_msg_size is the maximum individual message size.
     *
     * @generated from protobuf field: int32 max_msg_size = 7
     */
    maxMsgSize: number;
    /**
     * max_consumers is the maximum consumer count.
     *
     * @generated from protobuf field: int32 max_consumers = 8
     */
    maxConsumers: number;
    /**
     * discard is the discard policy when limits are reached.
     *
     * @generated from protobuf field: agency.policy.v1.DiscardPolicy discard = 9
     */
    discard: DiscardPolicy;
    /**
     * sources are source streams for aggregation.
     *
     * @generated from protobuf field: repeated agency.policy.v1.StreamSource sources = 10
     */
    sources: StreamSource[];
    /**
     * republish defines republishing rules.
     *
     * @generated from protobuf field: repeated agency.policy.v1.Republish republish = 11
     */
    republish: Republish[];
    /**
     * dedup_window is the deduplication window duration.
     *
     * @generated from protobuf field: google.protobuf.Duration dedup_window = 12
     */
    dedupWindow?: Duration;
    /**
     * deny_delete prevents stream deletion.
     *
     * @generated from protobuf field: bool deny_delete = 13
     */
    denyDelete: boolean;
    /**
     * deny_purge prevents stream purging.
     *
     * @generated from protobuf field: bool deny_purge = 14
     */
    denyPurge: boolean;
    /**
     * allow_rollup_hdrs allows rollup headers.
     *
     * @generated from protobuf field: bool allow_rollup_hdrs = 15
     */
    allowRollupHdrs: boolean;
    /**
     * allow_direct allows direct get access.
     *
     * @generated from protobuf field: bool allow_direct = 16
     */
    allowDirect: boolean;
    /**
     * mirror_direct allows direct access on mirrors.
     *
     * @generated from protobuf field: bool mirror_direct = 17
     */
    mirrorDirect: boolean;
    /**
     * discard_new_per_subject discards new messages when per-subject limit reached.
     *
     * @generated from protobuf field: bool discard_new_per_subject = 18
     */
    discardNewPerSubject: boolean;
    /**
     * mirror defines single-source stream mirroring for replication.
     *
     * @generated from protobuf field: agency.policy.v1.StreamSource mirror = 19
     */
    mirror?: StreamSource;
    /**
     * placement defines stream placement constraints in clustered deployments.
     *
     * @generated from protobuf field: agency.policy.v1.StreamPlacement placement = 20
     */
    placement?: StreamPlacement;
    /**
     * subject_transform defines subject transformation on ingest or egress.
     *
     * @generated from protobuf field: agency.policy.v1.SubjectTransform subject_transform = 21
     */
    subjectTransform?: SubjectTransform;
    /**
     * compression defines the compression algorithm for the stream.
     *
     * @generated from protobuf field: agency.policy.v1.CompressionAlgorithm compression = 22
     */
    compression: CompressionAlgorithm;
    /**
     * consumer_limits defines stream-level consumer constraints.
     *
     * @generated from protobuf field: agency.policy.v1.StreamConsumerLimits consumer_limits = 23
     */
    consumerLimits?: StreamConsumerLimits;
    /**
     * metadata is user-defined metadata for the stream.
     *
     * @generated from protobuf field: map<string, string> metadata = 24
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * allow_msg_schedules enables JetStream message schedules (ADR-51).
     * Requires allow_msg_ttl for Nats-Schedule-TTL.
     *
     * @generated from protobuf field: bool allow_msg_schedules = 25
     */
    allowMsgSchedules: boolean;
    /**
     * allow_msg_ttl enables per-message TTL (Nats-TTL header).
     *
     * @generated from protobuf field: bool allow_msg_ttl = 26
     */
    allowMsgTtl: boolean;
}
/**
 * ConsumerPolicy defines consumer configuration.
 *
 * @generated from protobuf message agency.policy.v1.ConsumerPolicy
 */
export interface ConsumerPolicy {
    /**
     * max_deliver is the maximum delivery attempts.
     *
     * @generated from protobuf field: uint32 max_deliver = 1
     */
    maxDeliver: number;
    /**
     * backoff are exponential backoff durations.
     *
     * @generated from protobuf field: repeated google.protobuf.Duration backoff = 2
     */
    backoff: Duration[];
    /**
     * max_ack_pending is the maximum unacknowledged messages.
     *
     * @generated from protobuf field: uint32 max_ack_pending = 3
     */
    maxAckPending: number;
    /**
     * ack_wait is the acknowledgment timeout.
     *
     * @generated from protobuf field: google.protobuf.Duration ack_wait = 4
     */
    ackWait?: Duration;
    /**
     * dead_letter_subject is the DLQ subject for failed messages.
     *
     * @generated from protobuf field: string dead_letter_subject = 5
     */
    deadLetterSubject: string;
    /**
     * ack_policy is the acknowledgment policy.
     *
     * @generated from protobuf field: agency.policy.v1.AckPolicy ack_policy = 6
     */
    ackPolicy: AckPolicy;
    /**
     * deliver_policy is the delivery policy.
     *
     * @generated from protobuf field: agency.policy.v1.DeliverPolicy deliver_policy = 7
     */
    deliverPolicy: DeliverPolicy;
    /**
     * replay_policy is the replay policy.
     *
     * @generated from protobuf field: agency.policy.v1.ReplayPolicy replay_policy = 8
     */
    replayPolicy: ReplayPolicy;
    /**
     * filter_subject filters messages by subject.
     *
     * @generated from protobuf field: string filter_subject = 9
     */
    filterSubject: string;
    /**
     * rate_limit_bps is the delivery rate limit in bits per second.
     *
     * @generated from protobuf field: uint64 rate_limit_bps = 10
     */
    rateLimitBps: bigint;
    /**
     * max_waiting is the maximum pull consumers waiting.
     *
     * @generated from protobuf field: int32 max_waiting = 11
     */
    maxWaiting: number;
    /**
     * max_batch is the maximum batch size for pull consumers.
     *
     * @generated from protobuf field: int32 max_batch = 12
     */
    maxBatch: number;
    /**
     * max_expires is the maximum pull expiration.
     *
     * @generated from protobuf field: google.protobuf.Duration max_expires = 13
     */
    maxExpires?: Duration;
    /**
     * inactive_threshold is the consumer cleanup threshold.
     *
     * @generated from protobuf field: google.protobuf.Duration inactive_threshold = 14
     */
    inactiveThreshold?: Duration;
    /**
     * flow_control enables flow control.
     *
     * @generated from protobuf field: bool flow_control = 15
     */
    flowControl: boolean;
    /**
     * idle_heartbeat is the heartbeat interval.
     *
     * @generated from protobuf field: google.protobuf.Duration idle_heartbeat = 16
     */
    idleHeartbeat?: Duration;
    /**
     * headers_only delivers only headers.
     *
     * @generated from protobuf field: bool headers_only = 17
     */
    headersOnly: boolean;
    /**
     * mem_storage uses memory storage for consumer state.
     *
     * @generated from protobuf field: bool mem_storage = 18
     */
    memStorage: boolean;
}
/**
 * PlacementPolicy defines leafnode and federation topology.
 *
 * @generated from protobuf message agency.policy.v1.PlacementPolicy
 */
export interface PlacementPolicy {
    /**
     * leafnode_export_subjects are subjects exported to leafnodes.
     *
     * @generated from protobuf field: repeated string leafnode_export_subjects = 1
     */
    leafnodeExportSubjects: string[];
    /**
     * leafnode_import_subjects are subjects imported from leafnodes.
     *
     * @generated from protobuf field: repeated string leafnode_import_subjects = 2
     */
    leafnodeImportSubjects: string[];
    /**
     * tool_subject_prefixes are subject prefixes for tool dispatch routing.
     *
     * @generated from protobuf field: repeated string tool_subject_prefixes = 3
     */
    toolSubjectPrefixes: string[];
    /**
     * cluster_tags are placement constraints for clustered deployments.
     *
     * @generated from protobuf field: repeated string cluster_tags = 4
     */
    clusterTags: string[];
    /**
     * node_restrictions defines per-node-type constraints (IoT, edge).
     *
     * @generated from protobuf field: agency.policy.v1.NodeRestrictions node_restrictions = 5
     */
    nodeRestrictions?: NodeRestrictions;
    /**
     * export_policies are subject export ACL rules.
     *
     * @generated from protobuf field: repeated agency.policy.v1.SubjectACL export_policies = 6
     */
    exportPolicies: SubjectACL[];
    /**
     * import_policies are subject import ACL rules.
     *
     * @generated from protobuf field: repeated agency.policy.v1.SubjectACL import_policies = 7
     */
    importPolicies: SubjectACL[];
    /**
     * federation_subject_filter restricts federation subjects (default: fed.>).
     *
     * @generated from protobuf field: string federation_subject_filter = 8
     */
    federationSubjectFilter: string;
    /**
     * deny_cross_tenant prevents cross-tenant subject access.
     *
     * @generated from protobuf field: bool deny_cross_tenant = 9
     */
    denyCrossTenant: boolean;
}
/**
 * NodeRestrictions defines constraints for edge/IoT nodes.
 *
 * @generated from protobuf message agency.policy.v1.NodeRestrictions
 */
export interface NodeRestrictions {
    /**
     * publish_only restricts node to publish-only (no subscriptions).
     *
     * @generated from protobuf field: bool publish_only = 1
     */
    publishOnly: boolean;
    /**
     * allowed_publish_subjects restricts publishing to specific subjects.
     *
     * @generated from protobuf field: repeated string allowed_publish_subjects = 2
     */
    allowedPublishSubjects: string[];
    /**
     * denied_publish_subjects prevents publishing to specific subjects.
     *
     * @generated from protobuf field: repeated string denied_publish_subjects = 3
     */
    deniedPublishSubjects: string[];
    /**
     * allowed_subscribe_subjects restricts subscriptions to specific subjects.
     *
     * @generated from protobuf field: repeated string allowed_subscribe_subjects = 4
     */
    allowedSubscribeSubjects: string[];
    /**
     * max_payload_size limits message payload size (bytes).
     *
     * @generated from protobuf field: int64 max_payload_size = 5
     */
    maxPayloadSize: bigint;
    /**
     * rate_limit_msgs_per_sec limits message publish rate.
     *
     * @generated from protobuf field: int32 rate_limit_msgs_per_sec = 6
     */
    rateLimitMsgsPerSec: number;
    /**
     * require_encryption enforces AGE encryption for all publishes.
     *
     * @generated from protobuf field: bool require_encryption = 7
     */
    requireEncryption: boolean;
}
/**
 * SubjectACL defines subject-level access control.
 *
 * @generated from protobuf message agency.policy.v1.SubjectACL
 */
export interface SubjectACL {
    /**
     * subject_pattern is the subject pattern (supports wildcards).
     *
     * @generated from protobuf field: string subject_pattern = 1
     */
    subjectPattern: string;
    /**
     * permission defines the access level.
     *
     * @generated from protobuf field: agency.policy.v1.SubjectPermission permission = 2
     */
    permission: SubjectPermission;
    /**
     * node_types restricts this ACL to specific node types.
     *
     * @generated from protobuf field: repeated agency.policy.v1.NodeType node_types = 3
     */
    nodeTypes: NodeType[];
    /**
     * tenant_filter restricts to specific tenants (empty = all).
     *
     * @generated from protobuf field: repeated string tenant_filter = 4
     */
    tenantFilter: string[];
    /**
     * description explains the ACL rule.
     *
     * @generated from protobuf field: string description = 5
     */
    description: string;
}
/**
 * RetentionPolicy defines how messages are retained in a stream.
 *
 * @generated from protobuf enum agency.policy.v1.RetentionPolicy
 */
export enum RetentionPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: RETENTION_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * LIMITS retains based on size/age/count limits.
     *
     * @generated from protobuf enum value: RETENTION_POLICY_LIMITS = 1;
     */
    LIMITS = 1,
    /**
     * INTEREST retains based on consumer interest.
     *
     * @generated from protobuf enum value: RETENTION_POLICY_INTEREST = 2;
     */
    INTEREST = 2,
    /**
     * WORK_QUEUE retains until acknowledged.
     *
     * @generated from protobuf enum value: RETENTION_POLICY_WORK_QUEUE = 3;
     */
    WORK_QUEUE = 3
}
/**
 * AckPolicy defines message acknowledgment requirements.
 *
 * @generated from protobuf enum agency.policy.v1.AckPolicy
 */
export enum AckPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: ACK_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * EXPLICIT requires explicit acknowledgment.
     *
     * @generated from protobuf enum value: ACK_POLICY_ACK_EXPLICIT = 1;
     */
    ACK_EXPLICIT = 1,
    /**
     * ALL requires all messages in batch to be acked.
     *
     * @generated from protobuf enum value: ACK_POLICY_ACK_ALL = 2;
     */
    ACK_ALL = 2,
    /**
     * NONE does not require acknowledgment.
     *
     * @generated from protobuf enum value: ACK_POLICY_ACK_NONE = 3;
     */
    ACK_NONE = 3
}
/**
 * ReplayPolicy defines where to start consuming.
 *
 * @generated from protobuf enum agency.policy.v1.ReplayPolicy
 */
export enum ReplayPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: REPLAY_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * INSTANT starts from the latest message.
     *
     * @generated from protobuf enum value: REPLAY_POLICY_REPLAY_INSTANT = 1;
     */
    REPLAY_INSTANT = 1,
    /**
     * ORIGINAL starts from the first message.
     *
     * @generated from protobuf enum value: REPLAY_POLICY_REPLAY_ORIGINAL = 2;
     */
    REPLAY_ORIGINAL = 2,
    /**
     * BY_START_SEQUENCE starts from a specific sequence.
     *
     * @generated from protobuf enum value: REPLAY_POLICY_REPLAY_BY_START_SEQUENCE = 3;
     */
    REPLAY_BY_START_SEQUENCE = 3,
    /**
     * BY_START_TIME starts from a specific timestamp.
     *
     * @generated from protobuf enum value: REPLAY_POLICY_REPLAY_BY_START_TIME = 4;
     */
    REPLAY_BY_START_TIME = 4
}
/**
 * DeliverPolicy defines message delivery mode.
 *
 * @generated from protobuf enum agency.policy.v1.DeliverPolicy
 */
export enum DeliverPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: DELIVER_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * ALL delivers all available messages.
     *
     * @generated from protobuf enum value: DELIVER_POLICY_DELIVER_ALL = 1;
     */
    DELIVER_ALL = 1,
    /**
     * LAST delivers only the last message per subject.
     *
     * @generated from protobuf enum value: DELIVER_POLICY_DELIVER_LAST = 2;
     */
    DELIVER_LAST = 2,
    /**
     * NEW delivers only new messages.
     *
     * @generated from protobuf enum value: DELIVER_POLICY_DELIVER_NEW = 3;
     */
    DELIVER_NEW = 3,
    /**
     * BY_START_SEQUENCE delivers from a specific sequence.
     *
     * @generated from protobuf enum value: DELIVER_POLICY_DELIVER_BY_START_SEQUENCE = 4;
     */
    DELIVER_BY_START_SEQUENCE = 4,
    /**
     * BY_START_TIME delivers from a specific timestamp.
     *
     * @generated from protobuf enum value: DELIVER_POLICY_DELIVER_BY_START_TIME = 5;
     */
    DELIVER_BY_START_TIME = 5,
    /**
     * LAST_PER_SUBJECT delivers the last message for each subject.
     *
     * @generated from protobuf enum value: DELIVER_POLICY_DELIVER_LAST_PER_SUBJECT = 6;
     */
    DELIVER_LAST_PER_SUBJECT = 6
}
/**
 * CompressionAlgorithm defines stream compression options.
 *
 * @generated from protobuf enum agency.policy.v1.CompressionAlgorithm
 */
export enum CompressionAlgorithm {
    /**
     * UNSPECIFIED defaults to no compression.
     *
     * @generated from protobuf enum value: COMPRESSION_ALGORITHM_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * NONE disables compression.
     *
     * @generated from protobuf enum value: COMPRESSION_ALGORITHM_NONE = 1;
     */
    NONE = 1,
    /**
     * S2 uses S2 compression (fast, good ratio).
     *
     * @generated from protobuf enum value: COMPRESSION_ALGORITHM_S2 = 2;
     */
    S2 = 2
}
/**
 * DiscardPolicy defines what to discard when limits are reached.
 *
 * @generated from protobuf enum agency.policy.v1.DiscardPolicy
 */
export enum DiscardPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: DISCARD_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * OLD discards old messages.
     *
     * @generated from protobuf enum value: DISCARD_POLICY_DISCARD_OLD = 1;
     */
    DISCARD_OLD = 1,
    /**
     * NEW discards new messages.
     *
     * @generated from protobuf enum value: DISCARD_POLICY_DISCARD_NEW = 2;
     */
    DISCARD_NEW = 2
}
/**
 * SubjectPermission defines subject access levels.
 *
 * @generated from protobuf enum agency.policy.v1.SubjectPermission
 */
export enum SubjectPermission {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SUBJECT_PERMISSION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * ALLOW grants access to the subject.
     *
     * @generated from protobuf enum value: SUBJECT_PERMISSION_ALLOW = 1;
     */
    ALLOW = 1,
    /**
     * DENY blocks access to the subject.
     *
     * @generated from protobuf enum value: SUBJECT_PERMISSION_DENY = 2;
     */
    DENY = 2,
    /**
     * PUBLISH_ONLY allows publishing but not subscribing.
     *
     * @generated from protobuf enum value: SUBJECT_PERMISSION_PUBLISH_ONLY = 3;
     */
    PUBLISH_ONLY = 3,
    /**
     * SUBSCRIBE_ONLY allows subscribing but not publishing.
     *
     * @generated from protobuf enum value: SUBJECT_PERMISSION_SUBSCRIBE_ONLY = 4;
     */
    SUBSCRIBE_ONLY = 4
}
/**
 * NodeType identifies node deployment type.
 *
 * @generated from protobuf enum agency.policy.v1.NodeType
 */
export enum NodeType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: NODE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * CLOUD is a cloud-hosted node (full capabilities).
     *
     * @generated from protobuf enum value: NODE_TYPE_CLOUD = 1;
     */
    CLOUD = 1,
    /**
     * EDGE is an edge node (regional, constrained resources).
     *
     * @generated from protobuf enum value: NODE_TYPE_EDGE = 2;
     */
    EDGE = 2,
    /**
     * IOT is an IoT device (publish-only, specific subjects).
     *
     * @generated from protobuf enum value: NODE_TYPE_IOT = 3;
     */
    IOT = 3,
    /**
     * FEDERATION is a federation bridge node.
     *
     * @generated from protobuf enum value: NODE_TYPE_FEDERATION = 4;
     */
    FEDERATION = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class StreamSource$Type extends MessageType<StreamSource> {
    constructor() {
        super("agency.policy.v1.StreamSource", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "opt_start_seq", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "opt_start_time", kind: "message", T: () => Duration },
            { no: 4, name: "filter_subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 5, name: "external", kind: "message", T: () => ExternalStream },
            { no: 6, name: "subject_transforms", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SubjectTransform, options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 7, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<StreamSource>): StreamSource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.optStartSeq = 0n;
        message.filterSubject = "";
        message.subjectTransforms = [];
        message.domain = "";
        if (value !== undefined)
            reflectionMergePartial<StreamSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamSource): StreamSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* uint64 opt_start_seq */ 2:
                    message.optStartSeq = reader.uint64().toBigInt();
                    break;
                case /* google.protobuf.Duration opt_start_time */ 3:
                    message.optStartTime = Duration.internalBinaryRead(reader, reader.uint32(), options, message.optStartTime);
                    break;
                case /* string filter_subject */ 4:
                    message.filterSubject = reader.string();
                    break;
                case /* agency.policy.v1.ExternalStream external */ 5:
                    message.external = ExternalStream.internalBinaryRead(reader, reader.uint32(), options, message.external);
                    break;
                case /* repeated agency.policy.v1.SubjectTransform subject_transforms */ 6:
                    message.subjectTransforms.push(SubjectTransform.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string domain */ 7:
                    message.domain = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* uint64 opt_start_seq = 2; */
        if (message.optStartSeq !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.optStartSeq);
        /* google.protobuf.Duration opt_start_time = 3; */
        if (message.optStartTime)
            Duration.internalBinaryWrite(message.optStartTime, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string filter_subject = 4; */
        if (message.filterSubject !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.filterSubject);
        /* agency.policy.v1.ExternalStream external = 5; */
        if (message.external)
            ExternalStream.internalBinaryWrite(message.external, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.policy.v1.SubjectTransform subject_transforms = 6; */
        for (let i = 0; i < message.subjectTransforms.length; i++)
            SubjectTransform.internalBinaryWrite(message.subjectTransforms[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string domain = 7; */
        if (message.domain !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.domain);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.StreamSource
 */
export const StreamSource = new StreamSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalStream$Type extends MessageType<ExternalStream> {
    constructor() {
        super("agency.policy.v1.ExternalStream", [
            { no: 1, name: "api_prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "deliver_prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ExternalStream>): ExternalStream {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.apiPrefix = "";
        message.deliverPrefix = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalStream>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalStream): ExternalStream {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string api_prefix */ 1:
                    message.apiPrefix = reader.string();
                    break;
                case /* string deliver_prefix */ 2:
                    message.deliverPrefix = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalStream, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string api_prefix = 1; */
        if (message.apiPrefix !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.apiPrefix);
        /* string deliver_prefix = 2; */
        if (message.deliverPrefix !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deliverPrefix);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.ExternalStream
 */
export const ExternalStream = new ExternalStream$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Republish$Type extends MessageType<Republish> {
    constructor() {
        super("agency.policy.v1.Republish", [
            { no: 1, name: "source", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "destination", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "headers_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Republish>): Republish {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.source = "";
        message.destination = "";
        message.headersOnly = false;
        if (value !== undefined)
            reflectionMergePartial<Republish>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Republish): Republish {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string source */ 1:
                    message.source = reader.string();
                    break;
                case /* string destination */ 2:
                    message.destination = reader.string();
                    break;
                case /* bool headers_only */ 3:
                    message.headersOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Republish, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string source = 1; */
        if (message.source !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.source);
        /* string destination = 2; */
        if (message.destination !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.destination);
        /* bool headers_only = 3; */
        if (message.headersOnly !== false)
            writer.tag(3, WireType.Varint).bool(message.headersOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.Republish
 */
export const Republish = new Republish$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubjectTransform$Type extends MessageType<SubjectTransform> {
    constructor() {
        super("agency.policy.v1.SubjectTransform", [
            { no: 1, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "dest", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<SubjectTransform>): SubjectTransform {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.src = "";
        message.dest = "";
        if (value !== undefined)
            reflectionMergePartial<SubjectTransform>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubjectTransform): SubjectTransform {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src */ 1:
                    message.src = reader.string();
                    break;
                case /* string dest */ 2:
                    message.dest = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubjectTransform, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src = 1; */
        if (message.src !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.src);
        /* string dest = 2; */
        if (message.dest !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dest);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.SubjectTransform
 */
export const SubjectTransform = new SubjectTransform$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamPlacement$Type extends MessageType<StreamPlacement> {
    constructor() {
        super("agency.policy.v1.StreamPlacement", [
            { no: 1, name: "cluster", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 2, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "64" } } } } } }
        ]);
    }
    create(value?: PartialMessage<StreamPlacement>): StreamPlacement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cluster = "";
        message.tags = [];
        if (value !== undefined)
            reflectionMergePartial<StreamPlacement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamPlacement): StreamPlacement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string cluster */ 1:
                    message.cluster = reader.string();
                    break;
                case /* repeated string tags */ 2:
                    message.tags.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamPlacement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string cluster = 1; */
        if (message.cluster !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.cluster);
        /* repeated string tags = 2; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.tags[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.StreamPlacement
 */
export const StreamPlacement = new StreamPlacement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamConsumerLimits$Type extends MessageType<StreamConsumerLimits> {
    constructor() {
        super("agency.policy.v1.StreamConsumerLimits", [
            { no: 1, name: "inactive_threshold", kind: "message", T: () => Duration },
            { no: 2, name: "max_ack_pending", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 1000000, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<StreamConsumerLimits>): StreamConsumerLimits {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.maxAckPending = 0;
        if (value !== undefined)
            reflectionMergePartial<StreamConsumerLimits>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamConsumerLimits): StreamConsumerLimits {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration inactive_threshold */ 1:
                    message.inactiveThreshold = Duration.internalBinaryRead(reader, reader.uint32(), options, message.inactiveThreshold);
                    break;
                case /* uint32 max_ack_pending */ 2:
                    message.maxAckPending = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamConsumerLimits, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration inactive_threshold = 1; */
        if (message.inactiveThreshold)
            Duration.internalBinaryWrite(message.inactiveThreshold, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* uint32 max_ack_pending = 2; */
        if (message.maxAckPending !== 0)
            writer.tag(2, WireType.Varint).uint32(message.maxAckPending);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.StreamConsumerLimits
 */
export const StreamConsumerLimits = new StreamConsumerLimits$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamPolicy$Type extends MessageType<StreamPolicy> {
    constructor() {
        super("agency.policy.v1.StreamPolicy", [
            { no: 1, name: "retention", kind: "enum", T: () => ["agency.policy.v1.RetentionPolicy", RetentionPolicy, "RETENTION_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "replicas", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 5, gte: 1 } } } },
            { no: 3, name: "max_age", kind: "message", T: () => Duration },
            { no: 4, name: "max_msgs_per_subject", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "-1" } } } },
            { no: 5, name: "max_msgs", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "-1" } } } },
            { no: 6, name: "max_bytes", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "-1" } } } },
            { no: 7, name: "max_msg_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: -1 } } } },
            { no: 8, name: "max_consumers", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: -1 } } } },
            { no: 9, name: "discard", kind: "enum", T: () => ["agency.policy.v1.DiscardPolicy", DiscardPolicy, "DISCARD_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 10, name: "sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StreamSource, options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 11, name: "republish", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Republish, options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 12, name: "dedup_window", kind: "message", T: () => Duration },
            { no: 13, name: "deny_delete", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "deny_purge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "allow_rollup_hdrs", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "allow_direct", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "mirror_direct", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "discard_new_per_subject", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "mirror", kind: "message", T: () => StreamSource },
            { no: 20, name: "placement", kind: "message", T: () => StreamPlacement },
            { no: 21, name: "subject_transform", kind: "message", T: () => SubjectTransform },
            { no: 22, name: "compression", kind: "enum", T: () => ["agency.policy.v1.CompressionAlgorithm", CompressionAlgorithm, "COMPRESSION_ALGORITHM_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 23, name: "consumer_limits", kind: "message", T: () => StreamConsumerLimits },
            { no: 24, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 25, name: "allow_msg_schedules", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "allow_msg_ttl", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<StreamPolicy>): StreamPolicy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.retention = 0;
        message.replicas = 0;
        message.maxMsgsPerSubject = 0n;
        message.maxMsgs = 0n;
        message.maxBytes = 0n;
        message.maxMsgSize = 0;
        message.maxConsumers = 0;
        message.discard = 0;
        message.sources = [];
        message.republish = [];
        message.denyDelete = false;
        message.denyPurge = false;
        message.allowRollupHdrs = false;
        message.allowDirect = false;
        message.mirrorDirect = false;
        message.discardNewPerSubject = false;
        message.compression = 0;
        message.metadata = {};
        message.allowMsgSchedules = false;
        message.allowMsgTtl = false;
        if (value !== undefined)
            reflectionMergePartial<StreamPolicy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamPolicy): StreamPolicy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.policy.v1.RetentionPolicy retention */ 1:
                    message.retention = reader.int32();
                    break;
                case /* uint32 replicas */ 2:
                    message.replicas = reader.uint32();
                    break;
                case /* google.protobuf.Duration max_age */ 3:
                    message.maxAge = Duration.internalBinaryRead(reader, reader.uint32(), options, message.maxAge);
                    break;
                case /* int64 max_msgs_per_subject */ 4:
                    message.maxMsgsPerSubject = reader.int64().toBigInt();
                    break;
                case /* int64 max_msgs */ 5:
                    message.maxMsgs = reader.int64().toBigInt();
                    break;
                case /* int64 max_bytes */ 6:
                    message.maxBytes = reader.int64().toBigInt();
                    break;
                case /* int32 max_msg_size */ 7:
                    message.maxMsgSize = reader.int32();
                    break;
                case /* int32 max_consumers */ 8:
                    message.maxConsumers = reader.int32();
                    break;
                case /* agency.policy.v1.DiscardPolicy discard */ 9:
                    message.discard = reader.int32();
                    break;
                case /* repeated agency.policy.v1.StreamSource sources */ 10:
                    message.sources.push(StreamSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated agency.policy.v1.Republish republish */ 11:
                    message.republish.push(Republish.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Duration dedup_window */ 12:
                    message.dedupWindow = Duration.internalBinaryRead(reader, reader.uint32(), options, message.dedupWindow);
                    break;
                case /* bool deny_delete */ 13:
                    message.denyDelete = reader.bool();
                    break;
                case /* bool deny_purge */ 14:
                    message.denyPurge = reader.bool();
                    break;
                case /* bool allow_rollup_hdrs */ 15:
                    message.allowRollupHdrs = reader.bool();
                    break;
                case /* bool allow_direct */ 16:
                    message.allowDirect = reader.bool();
                    break;
                case /* bool mirror_direct */ 17:
                    message.mirrorDirect = reader.bool();
                    break;
                case /* bool discard_new_per_subject */ 18:
                    message.discardNewPerSubject = reader.bool();
                    break;
                case /* agency.policy.v1.StreamSource mirror */ 19:
                    message.mirror = StreamSource.internalBinaryRead(reader, reader.uint32(), options, message.mirror);
                    break;
                case /* agency.policy.v1.StreamPlacement placement */ 20:
                    message.placement = StreamPlacement.internalBinaryRead(reader, reader.uint32(), options, message.placement);
                    break;
                case /* agency.policy.v1.SubjectTransform subject_transform */ 21:
                    message.subjectTransform = SubjectTransform.internalBinaryRead(reader, reader.uint32(), options, message.subjectTransform);
                    break;
                case /* agency.policy.v1.CompressionAlgorithm compression */ 22:
                    message.compression = reader.int32();
                    break;
                case /* agency.policy.v1.StreamConsumerLimits consumer_limits */ 23:
                    message.consumerLimits = StreamConsumerLimits.internalBinaryRead(reader, reader.uint32(), options, message.consumerLimits);
                    break;
                case /* map<string, string> metadata */ 24:
                    this.binaryReadMap24(message.metadata, reader, options);
                    break;
                case /* bool allow_msg_schedules */ 25:
                    message.allowMsgSchedules = reader.bool();
                    break;
                case /* bool allow_msg_ttl */ 26:
                    message.allowMsgTtl = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap24(map: StreamPolicy["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof StreamPolicy["metadata"] | undefined, val: StreamPolicy["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.policy.v1.StreamPolicy.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: StreamPolicy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.policy.v1.RetentionPolicy retention = 1; */
        if (message.retention !== 0)
            writer.tag(1, WireType.Varint).int32(message.retention);
        /* uint32 replicas = 2; */
        if (message.replicas !== 0)
            writer.tag(2, WireType.Varint).uint32(message.replicas);
        /* google.protobuf.Duration max_age = 3; */
        if (message.maxAge)
            Duration.internalBinaryWrite(message.maxAge, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int64 max_msgs_per_subject = 4; */
        if (message.maxMsgsPerSubject !== 0n)
            writer.tag(4, WireType.Varint).int64(message.maxMsgsPerSubject);
        /* int64 max_msgs = 5; */
        if (message.maxMsgs !== 0n)
            writer.tag(5, WireType.Varint).int64(message.maxMsgs);
        /* int64 max_bytes = 6; */
        if (message.maxBytes !== 0n)
            writer.tag(6, WireType.Varint).int64(message.maxBytes);
        /* int32 max_msg_size = 7; */
        if (message.maxMsgSize !== 0)
            writer.tag(7, WireType.Varint).int32(message.maxMsgSize);
        /* int32 max_consumers = 8; */
        if (message.maxConsumers !== 0)
            writer.tag(8, WireType.Varint).int32(message.maxConsumers);
        /* agency.policy.v1.DiscardPolicy discard = 9; */
        if (message.discard !== 0)
            writer.tag(9, WireType.Varint).int32(message.discard);
        /* repeated agency.policy.v1.StreamSource sources = 10; */
        for (let i = 0; i < message.sources.length; i++)
            StreamSource.internalBinaryWrite(message.sources[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.policy.v1.Republish republish = 11; */
        for (let i = 0; i < message.republish.length; i++)
            Republish.internalBinaryWrite(message.republish[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration dedup_window = 12; */
        if (message.dedupWindow)
            Duration.internalBinaryWrite(message.dedupWindow, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* bool deny_delete = 13; */
        if (message.denyDelete !== false)
            writer.tag(13, WireType.Varint).bool(message.denyDelete);
        /* bool deny_purge = 14; */
        if (message.denyPurge !== false)
            writer.tag(14, WireType.Varint).bool(message.denyPurge);
        /* bool allow_rollup_hdrs = 15; */
        if (message.allowRollupHdrs !== false)
            writer.tag(15, WireType.Varint).bool(message.allowRollupHdrs);
        /* bool allow_direct = 16; */
        if (message.allowDirect !== false)
            writer.tag(16, WireType.Varint).bool(message.allowDirect);
        /* bool mirror_direct = 17; */
        if (message.mirrorDirect !== false)
            writer.tag(17, WireType.Varint).bool(message.mirrorDirect);
        /* bool discard_new_per_subject = 18; */
        if (message.discardNewPerSubject !== false)
            writer.tag(18, WireType.Varint).bool(message.discardNewPerSubject);
        /* agency.policy.v1.StreamSource mirror = 19; */
        if (message.mirror)
            StreamSource.internalBinaryWrite(message.mirror, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* agency.policy.v1.StreamPlacement placement = 20; */
        if (message.placement)
            StreamPlacement.internalBinaryWrite(message.placement, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* agency.policy.v1.SubjectTransform subject_transform = 21; */
        if (message.subjectTransform)
            SubjectTransform.internalBinaryWrite(message.subjectTransform, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* agency.policy.v1.CompressionAlgorithm compression = 22; */
        if (message.compression !== 0)
            writer.tag(22, WireType.Varint).int32(message.compression);
        /* agency.policy.v1.StreamConsumerLimits consumer_limits = 23; */
        if (message.consumerLimits)
            StreamConsumerLimits.internalBinaryWrite(message.consumerLimits, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> metadata = 24; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(24, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* bool allow_msg_schedules = 25; */
        if (message.allowMsgSchedules !== false)
            writer.tag(25, WireType.Varint).bool(message.allowMsgSchedules);
        /* bool allow_msg_ttl = 26; */
        if (message.allowMsgTtl !== false)
            writer.tag(26, WireType.Varint).bool(message.allowMsgTtl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.StreamPolicy
 */
export const StreamPolicy = new StreamPolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConsumerPolicy$Type extends MessageType<ConsumerPolicy> {
    constructor() {
        super("agency.policy.v1.ConsumerPolicy", [
            { no: 1, name: "max_deliver", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 1000, gte: 1 } } } },
            { no: 2, name: "backoff", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Duration, options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 3, name: "max_ack_pending", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 1000000, gte: 1 } } } },
            { no: 4, name: "ack_wait", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "dead_letter_subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 6, name: "ack_policy", kind: "enum", T: () => ["agency.policy.v1.AckPolicy", AckPolicy, "ACK_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 7, name: "deliver_policy", kind: "enum", T: () => ["agency.policy.v1.DeliverPolicy", DeliverPolicy, "DELIVER_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 8, name: "replay_policy", kind: "enum", T: () => ["agency.policy.v1.ReplayPolicy", ReplayPolicy, "REPLAY_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 9, name: "filter_subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 10, name: "rate_limit_bps", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "max_waiting", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000, gte: 0 } } } },
            { no: 12, name: "max_batch", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 0 } } } },
            { no: 13, name: "max_expires", kind: "message", T: () => Duration },
            { no: 14, name: "inactive_threshold", kind: "message", T: () => Duration },
            { no: 15, name: "flow_control", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "idle_heartbeat", kind: "message", T: () => Duration },
            { no: 17, name: "headers_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "mem_storage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ConsumerPolicy>): ConsumerPolicy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.maxDeliver = 0;
        message.backoff = [];
        message.maxAckPending = 0;
        message.deadLetterSubject = "";
        message.ackPolicy = 0;
        message.deliverPolicy = 0;
        message.replayPolicy = 0;
        message.filterSubject = "";
        message.rateLimitBps = 0n;
        message.maxWaiting = 0;
        message.maxBatch = 0;
        message.flowControl = false;
        message.headersOnly = false;
        message.memStorage = false;
        if (value !== undefined)
            reflectionMergePartial<ConsumerPolicy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConsumerPolicy): ConsumerPolicy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 max_deliver */ 1:
                    message.maxDeliver = reader.uint32();
                    break;
                case /* repeated google.protobuf.Duration backoff */ 2:
                    message.backoff.push(Duration.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* uint32 max_ack_pending */ 3:
                    message.maxAckPending = reader.uint32();
                    break;
                case /* google.protobuf.Duration ack_wait */ 4:
                    message.ackWait = Duration.internalBinaryRead(reader, reader.uint32(), options, message.ackWait);
                    break;
                case /* string dead_letter_subject */ 5:
                    message.deadLetterSubject = reader.string();
                    break;
                case /* agency.policy.v1.AckPolicy ack_policy */ 6:
                    message.ackPolicy = reader.int32();
                    break;
                case /* agency.policy.v1.DeliverPolicy deliver_policy */ 7:
                    message.deliverPolicy = reader.int32();
                    break;
                case /* agency.policy.v1.ReplayPolicy replay_policy */ 8:
                    message.replayPolicy = reader.int32();
                    break;
                case /* string filter_subject */ 9:
                    message.filterSubject = reader.string();
                    break;
                case /* uint64 rate_limit_bps */ 10:
                    message.rateLimitBps = reader.uint64().toBigInt();
                    break;
                case /* int32 max_waiting */ 11:
                    message.maxWaiting = reader.int32();
                    break;
                case /* int32 max_batch */ 12:
                    message.maxBatch = reader.int32();
                    break;
                case /* google.protobuf.Duration max_expires */ 13:
                    message.maxExpires = Duration.internalBinaryRead(reader, reader.uint32(), options, message.maxExpires);
                    break;
                case /* google.protobuf.Duration inactive_threshold */ 14:
                    message.inactiveThreshold = Duration.internalBinaryRead(reader, reader.uint32(), options, message.inactiveThreshold);
                    break;
                case /* bool flow_control */ 15:
                    message.flowControl = reader.bool();
                    break;
                case /* google.protobuf.Duration idle_heartbeat */ 16:
                    message.idleHeartbeat = Duration.internalBinaryRead(reader, reader.uint32(), options, message.idleHeartbeat);
                    break;
                case /* bool headers_only */ 17:
                    message.headersOnly = reader.bool();
                    break;
                case /* bool mem_storage */ 18:
                    message.memStorage = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConsumerPolicy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 max_deliver = 1; */
        if (message.maxDeliver !== 0)
            writer.tag(1, WireType.Varint).uint32(message.maxDeliver);
        /* repeated google.protobuf.Duration backoff = 2; */
        for (let i = 0; i < message.backoff.length; i++)
            Duration.internalBinaryWrite(message.backoff[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* uint32 max_ack_pending = 3; */
        if (message.maxAckPending !== 0)
            writer.tag(3, WireType.Varint).uint32(message.maxAckPending);
        /* google.protobuf.Duration ack_wait = 4; */
        if (message.ackWait)
            Duration.internalBinaryWrite(message.ackWait, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string dead_letter_subject = 5; */
        if (message.deadLetterSubject !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.deadLetterSubject);
        /* agency.policy.v1.AckPolicy ack_policy = 6; */
        if (message.ackPolicy !== 0)
            writer.tag(6, WireType.Varint).int32(message.ackPolicy);
        /* agency.policy.v1.DeliverPolicy deliver_policy = 7; */
        if (message.deliverPolicy !== 0)
            writer.tag(7, WireType.Varint).int32(message.deliverPolicy);
        /* agency.policy.v1.ReplayPolicy replay_policy = 8; */
        if (message.replayPolicy !== 0)
            writer.tag(8, WireType.Varint).int32(message.replayPolicy);
        /* string filter_subject = 9; */
        if (message.filterSubject !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.filterSubject);
        /* uint64 rate_limit_bps = 10; */
        if (message.rateLimitBps !== 0n)
            writer.tag(10, WireType.Varint).uint64(message.rateLimitBps);
        /* int32 max_waiting = 11; */
        if (message.maxWaiting !== 0)
            writer.tag(11, WireType.Varint).int32(message.maxWaiting);
        /* int32 max_batch = 12; */
        if (message.maxBatch !== 0)
            writer.tag(12, WireType.Varint).int32(message.maxBatch);
        /* google.protobuf.Duration max_expires = 13; */
        if (message.maxExpires)
            Duration.internalBinaryWrite(message.maxExpires, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration inactive_threshold = 14; */
        if (message.inactiveThreshold)
            Duration.internalBinaryWrite(message.inactiveThreshold, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* bool flow_control = 15; */
        if (message.flowControl !== false)
            writer.tag(15, WireType.Varint).bool(message.flowControl);
        /* google.protobuf.Duration idle_heartbeat = 16; */
        if (message.idleHeartbeat)
            Duration.internalBinaryWrite(message.idleHeartbeat, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* bool headers_only = 17; */
        if (message.headersOnly !== false)
            writer.tag(17, WireType.Varint).bool(message.headersOnly);
        /* bool mem_storage = 18; */
        if (message.memStorage !== false)
            writer.tag(18, WireType.Varint).bool(message.memStorage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.ConsumerPolicy
 */
export const ConsumerPolicy = new ConsumerPolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlacementPolicy$Type extends MessageType<PlacementPolicy> {
    constructor() {
        super("agency.policy.v1.PlacementPolicy", [
            { no: 1, name: "leafnode_export_subjects", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 2, name: "leafnode_import_subjects", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 3, name: "tool_subject_prefixes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 4, name: "cluster_tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 5, name: "node_restrictions", kind: "message", T: () => NodeRestrictions },
            { no: 6, name: "export_policies", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SubjectACL, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 7, name: "import_policies", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SubjectACL, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 8, name: "federation_subject_filter", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 9, name: "deny_cross_tenant", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PlacementPolicy>): PlacementPolicy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.leafnodeExportSubjects = [];
        message.leafnodeImportSubjects = [];
        message.toolSubjectPrefixes = [];
        message.clusterTags = [];
        message.exportPolicies = [];
        message.importPolicies = [];
        message.federationSubjectFilter = "";
        message.denyCrossTenant = false;
        if (value !== undefined)
            reflectionMergePartial<PlacementPolicy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PlacementPolicy): PlacementPolicy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string leafnode_export_subjects */ 1:
                    message.leafnodeExportSubjects.push(reader.string());
                    break;
                case /* repeated string leafnode_import_subjects */ 2:
                    message.leafnodeImportSubjects.push(reader.string());
                    break;
                case /* repeated string tool_subject_prefixes */ 3:
                    message.toolSubjectPrefixes.push(reader.string());
                    break;
                case /* repeated string cluster_tags */ 4:
                    message.clusterTags.push(reader.string());
                    break;
                case /* agency.policy.v1.NodeRestrictions node_restrictions */ 5:
                    message.nodeRestrictions = NodeRestrictions.internalBinaryRead(reader, reader.uint32(), options, message.nodeRestrictions);
                    break;
                case /* repeated agency.policy.v1.SubjectACL export_policies */ 6:
                    message.exportPolicies.push(SubjectACL.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated agency.policy.v1.SubjectACL import_policies */ 7:
                    message.importPolicies.push(SubjectACL.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string federation_subject_filter */ 8:
                    message.federationSubjectFilter = reader.string();
                    break;
                case /* bool deny_cross_tenant */ 9:
                    message.denyCrossTenant = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PlacementPolicy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string leafnode_export_subjects = 1; */
        for (let i = 0; i < message.leafnodeExportSubjects.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.leafnodeExportSubjects[i]);
        /* repeated string leafnode_import_subjects = 2; */
        for (let i = 0; i < message.leafnodeImportSubjects.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.leafnodeImportSubjects[i]);
        /* repeated string tool_subject_prefixes = 3; */
        for (let i = 0; i < message.toolSubjectPrefixes.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.toolSubjectPrefixes[i]);
        /* repeated string cluster_tags = 4; */
        for (let i = 0; i < message.clusterTags.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.clusterTags[i]);
        /* agency.policy.v1.NodeRestrictions node_restrictions = 5; */
        if (message.nodeRestrictions)
            NodeRestrictions.internalBinaryWrite(message.nodeRestrictions, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.policy.v1.SubjectACL export_policies = 6; */
        for (let i = 0; i < message.exportPolicies.length; i++)
            SubjectACL.internalBinaryWrite(message.exportPolicies[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.policy.v1.SubjectACL import_policies = 7; */
        for (let i = 0; i < message.importPolicies.length; i++)
            SubjectACL.internalBinaryWrite(message.importPolicies[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string federation_subject_filter = 8; */
        if (message.federationSubjectFilter !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.federationSubjectFilter);
        /* bool deny_cross_tenant = 9; */
        if (message.denyCrossTenant !== false)
            writer.tag(9, WireType.Varint).bool(message.denyCrossTenant);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.PlacementPolicy
 */
export const PlacementPolicy = new PlacementPolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NodeRestrictions$Type extends MessageType<NodeRestrictions> {
    constructor() {
        super("agency.policy.v1.NodeRestrictions", [
            { no: 1, name: "publish_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "allowed_publish_subjects", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 3, name: "denied_publish_subjects", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 4, name: "allowed_subscribe_subjects", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 5, name: "max_payload_size", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { lte: "10485760", gte: "0" } } } },
            { no: 6, name: "rate_limit_msgs_per_sec", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 0 } } } },
            { no: 7, name: "require_encryption", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<NodeRestrictions>): NodeRestrictions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.publishOnly = false;
        message.allowedPublishSubjects = [];
        message.deniedPublishSubjects = [];
        message.allowedSubscribeSubjects = [];
        message.maxPayloadSize = 0n;
        message.rateLimitMsgsPerSec = 0;
        message.requireEncryption = false;
        if (value !== undefined)
            reflectionMergePartial<NodeRestrictions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NodeRestrictions): NodeRestrictions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool publish_only */ 1:
                    message.publishOnly = reader.bool();
                    break;
                case /* repeated string allowed_publish_subjects */ 2:
                    message.allowedPublishSubjects.push(reader.string());
                    break;
                case /* repeated string denied_publish_subjects */ 3:
                    message.deniedPublishSubjects.push(reader.string());
                    break;
                case /* repeated string allowed_subscribe_subjects */ 4:
                    message.allowedSubscribeSubjects.push(reader.string());
                    break;
                case /* int64 max_payload_size */ 5:
                    message.maxPayloadSize = reader.int64().toBigInt();
                    break;
                case /* int32 rate_limit_msgs_per_sec */ 6:
                    message.rateLimitMsgsPerSec = reader.int32();
                    break;
                case /* bool require_encryption */ 7:
                    message.requireEncryption = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NodeRestrictions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool publish_only = 1; */
        if (message.publishOnly !== false)
            writer.tag(1, WireType.Varint).bool(message.publishOnly);
        /* repeated string allowed_publish_subjects = 2; */
        for (let i = 0; i < message.allowedPublishSubjects.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.allowedPublishSubjects[i]);
        /* repeated string denied_publish_subjects = 3; */
        for (let i = 0; i < message.deniedPublishSubjects.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.deniedPublishSubjects[i]);
        /* repeated string allowed_subscribe_subjects = 4; */
        for (let i = 0; i < message.allowedSubscribeSubjects.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.allowedSubscribeSubjects[i]);
        /* int64 max_payload_size = 5; */
        if (message.maxPayloadSize !== 0n)
            writer.tag(5, WireType.Varint).int64(message.maxPayloadSize);
        /* int32 rate_limit_msgs_per_sec = 6; */
        if (message.rateLimitMsgsPerSec !== 0)
            writer.tag(6, WireType.Varint).int32(message.rateLimitMsgsPerSec);
        /* bool require_encryption = 7; */
        if (message.requireEncryption !== false)
            writer.tag(7, WireType.Varint).bool(message.requireEncryption);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.NodeRestrictions
 */
export const NodeRestrictions = new NodeRestrictions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubjectACL$Type extends MessageType<SubjectACL> {
    constructor() {
        super("agency.policy.v1.SubjectACL", [
            { no: 1, name: "subject_pattern", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "permission", kind: "enum", T: () => ["agency.policy.v1.SubjectPermission", SubjectPermission, "SUBJECT_PERMISSION_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "node_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["agency.policy.v1.NodeType", NodeType, "NODE_TYPE_"], options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 4, name: "tenant_filter", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } } } },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<SubjectACL>): SubjectACL {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subjectPattern = "";
        message.permission = 0;
        message.nodeTypes = [];
        message.tenantFilter = [];
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<SubjectACL>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubjectACL): SubjectACL {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subject_pattern */ 1:
                    message.subjectPattern = reader.string();
                    break;
                case /* agency.policy.v1.SubjectPermission permission */ 2:
                    message.permission = reader.int32();
                    break;
                case /* repeated agency.policy.v1.NodeType node_types */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.nodeTypes.push(reader.int32());
                    else
                        message.nodeTypes.push(reader.int32());
                    break;
                case /* repeated string tenant_filter */ 4:
                    message.tenantFilter.push(reader.string());
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubjectACL, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subject_pattern = 1; */
        if (message.subjectPattern !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subjectPattern);
        /* agency.policy.v1.SubjectPermission permission = 2; */
        if (message.permission !== 0)
            writer.tag(2, WireType.Varint).int32(message.permission);
        /* repeated agency.policy.v1.NodeType node_types = 3; */
        if (message.nodeTypes.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.nodeTypes.length; i++)
                writer.int32(message.nodeTypes[i]);
            writer.join();
        }
        /* repeated string tenant_filter = 4; */
        for (let i = 0; i < message.tenantFilter.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.tenantFilter[i]);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.policy.v1.SubjectACL
 */
export const SubjectACL = new SubjectACL$Type();
